/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import clsx from 'clsx';
import React from 'react';
import { DashboardCard } from '../DashboardCard/DashboardCard';
import { DashboardCardProps } from '../DashboardCard/DashboardCard.props';
import { DashboardCardGridProps } from './DashboardCardGrid.props';

/**
 * Grid for dashboard cards.
 */
export const DashboardCardGrid = (props: DashboardCardGridProps): JSX.Element => {
  const { classes, dashboardCards } = props;

  const dashboardGridClass = clsx(`dashboard-card-grid`, classes);

  const getCards = (): Array<JSX.Element> => {
    return dashboardCards.map((card: DashboardCardProps) => {
      return (
        <li key={card.title}>
          <DashboardCard {...card} />
        </li>
      );
    });
  };

  if (!dashboardCards.length) {
    return <></>;
  }

  return <ul className={dashboardGridClass}>{getCards()}</ul>;
};
